import { useContext, useRef } from 'react';
import { CommunityUser, Thread } from '@juno/client-api/model';
import { ANALYTICS_CONFIGURATION } from '@juno/constants';
import { useSettings } from '@juno/utils';
import { useAnalyticsContext } from '../../Contexts/AnalyticsContext';
import { FeedContext } from '../../Feed';
import CommentEditor from '../CommentsRepliesSection/CommentEditor';

interface Props {
  thread: Thread;
  isInForum?: boolean;
  refetch: () => void;
}

export const CommentReply = ({ thread, isInForum, refetch }: Props) => {
  const { user } = useSettings();
  const feedContext = useContext(FeedContext);
  const userMentions = useRef<CommunityUser[]>(thread.tagged_users ?? []);
  const editorRef = useRef<any>(null);
  const { firehoseActivity } = useAnalyticsContext();

  return (
    <CommentEditor
      editorRef={editorRef}
      userMentions={userMentions}
      parentThreadId={thread.id}
      isReply={true}
      onSubmitSuccess={() => {
        refetch();
        feedContext?.setThreadToReplyTo(null);
        firehoseActivity(
          ANALYTICS_CONFIGURATION.FIREHOSE_OBJECTS.OBJECT_COMMUNITY,
          thread?.parent_id || '',
          null,
          `${user?.id || ''}`,
          isInForum
            ? ANALYTICS_CONFIGURATION.FIREHOSE_CATEGORIES.CATEGORY_FORUM
            : ANALYTICS_CONFIGURATION.FIREHOSE_CATEGORIES.CATEGORY_FEED,
          feedContext?.threadToReplyTo?.id === thread.id
            ? ANALYTICS_CONFIGURATION.FIREHOSE_ACTIONS.ACTION_COMMENT.value
            : ANALYTICS_CONFIGURATION.FIREHOSE_ACTIONS.ACTION_REPLY.value,
          '',
          null,
        );
        feedContext?.setThreadToReplyTo(null);
        editorRef.current?.setContent('');
      }}
      onCancel={() => feedContext?.setThreadToReplyTo(null)}
    />
  );
};
